import React from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { StageLayout } from '../StageLayout';
import { workflowSteps } from '../../../data/tracking';
const BEATS = [500, 1000, 1300, 1600, 1900, 2600];

/** The product difference — Precision Grip enters only now, as the practical answer. */
export function Page5Product() {
  const beat = useBeats(BEATS);
  return <StageLayout copy={<>
          <h2 className="max-w-[400px] font-headline text-[24px] font-extrabold leading-[1.1] text-white opacity-0-init animate-fade-in-up md:text-[40px]" data-id="element-215" data-mp="3gtw9qs0nsgdv">
            So why recreate this step manually?
          </h2>

          <p className={`mt-4 max-w-[380px] font-body text-sm leading-snug text-solventum-primary transition-[opacity,transform] duration-300 ease-out md:text-lg ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-216" data-mp="3przz5zerlxay">
            Precision Grip brings the attachment into the digital workflow.
          </p>

          <div className={`mt-6 border-l border-solventum-primary/40 pl-4 transition-[opacity,transform] duration-300 ease-out ${beat >= 6 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-217" data-mp="3gqjxj31rl1f6">
            <p className="font-headline text-[18px] font-extrabold leading-[1.15] text-white md:text-[26px]" data-id="element-218" data-mp="37wyl3qd2nw8x">
              Less manual recreation.
              <br data-id="element-219" data-mp="2y26n4lfkv7dm" />
              Less manual variability.
            </p>
          </div>
        </>} visual={<ol className="grid w-full max-w-[360px] grid-cols-2 gap-2.5" data-id="element-220" data-mp="2t0pjwj9mf8tv">
          {workflowSteps.map((step, index) => <li key={step.name} className={`flex flex-col overflow-hidden rounded-xl border border-white/12 transition-[opacity,transform] duration-200 ease-out ${beat > index + 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-221" data-mp="2p2a16rkkomm9" data-mpi={index}>
              <img src={step.image} alt={step.alt} className="h-[58px] w-full object-cover md:h-[74px]" data-id="element-222" data-mp="11djdtpi2fl82" />
              <p className="mt-auto px-2.5 py-1.5 font-body text-[11px] leading-tight text-white/70" data-id="element-223" data-mp="se65x19lb4pg">
                {step.name}
              </p>
            </li>)}
        </ol>} data-id="element-214" data-mp="hbdemrcv0afg" />;
}